define('BackInStockNotification.Views.Subscribe', [
    'Backbone',
    'Backbone.FormView',
    'BackInStockNotification.Model',
    'back_in_stock_notification_subscribe.tpl',
    'jQuery',
    'underscore',
    'SC.Configuration',
    'Utils'
],
function BackInStockNotificationViewsSubscribe(
    Backbone,
    BackboneFormView,
    Model,
    backInStockNotificationSubscribeTemplate,
    $,
    _,
    Configuration
) {
    'use strict';

    return Backbone.View.extend({
        template: backInStockNotificationSubscribeTemplate,

        events: {
            'click [data-action="show-bis-control"]': 'toggleBisControl',
            'submit form': 'saveTheForm'
        },

        bindings: {
            '[name="firstname"]': 'firstname',
            '[name="lastname"]': 'lastname',
            '[name="email"]': 'email'
        },

        initialize: function initialize(options) {
            this.application = options.application;
            this.pdp = options.pdp;
            this.pdpSelectedMatrixChilds = this.pdp.getSelectedMatrixChilds();
            this.pdpdItemInfo = this.pdp.getItemInfo();
            $(document).on('click', this.outsideClickEvent);
            this.setNewModel();

            BackboneFormView.add(this);
        },

        setNewModel: function setNewModel() {
            this.model = new Model();
            this.model.set('item', this.pdpdItemInfo.item);
        },

        outsideClickEvent: function outsideClickEvent(event) {
            var clickOnDropDownMenu;
            var $target;
            var $dropDownMenu;

            $target = $(event.target);
            $dropDownMenu = $('div[data-type="bis-control"]');
            clickOnDropDownMenu = $target
                .closest('div[data-type="backinstocknotification-control-placeholder"]').length ||
                $target.is($dropDownMenu);

            if (!clickOnDropDownMenu) {
                if ($dropDownMenu.is(':visible')) {
                    $dropDownMenu.slideUp();
                }
            }
        },

        toggleBisControl: function toggleBisControl(e) {
            var $control;
            e.preventDefault();
            // Check if the user is logged in
            $control = this.$('[data-type="bis-control"]');
            if ($control.is(':visible')) {
                $control.slideUp();
            } else {
                $control.slideDown();
            }
        },

        render: function render() {
            // if the control is currently visible then we remember that !
            this.isVisible = this.$('[data-type="bis-control"]').is(':visible');
            Backbone.View.prototype.render.apply(this);
        },

        destroy: function destroy() {
            $(document).off('click', this.outsideClickEvent);
            Backbone.View.prototype.destroy.apply(this);
        },

        // I called saveTheForm this method because the add method of the Backbone.FormView class overwrites
        // the saveForm method of the view (see the initialize method above)
        saveTheForm: function saveTheForm(e) {
            var self = this;
            var promise = BackboneFormView.saveForm.apply(this, arguments);

            e.preventDefault();
            this.$('[data-confirm-bin-message]').empty();

            return promise && promise.then(function promiseSuccessCallback() {
                self.setNewModel();
                self.render();
                self.showMessage(_('Success!!').translate(), 'success');
                self.$('[data-type="bis-control"]').delay(1000).slideUp();
                self.$('form').get(0).reset();
            }, function promiseErrorCallback(jqXhr) {
                jqXhr.preventDefault = true;
                self.showMessage(jqXhr.responseJSON.errorMessage, 'error');
            });
        },

        showMessage: function showMessage(message, type) {
            var $confirmationMessage = this
                .$('[data-confirm-bin-message]')[
                    type === 'success' ? 'removeClass' : 'addClass'
                ]('back-in-stock-notification-message-error')[
                    type === 'success' ? 'addClass' : 'removeClass'
                ]('back-in-stock-notification-message-success');

            // this.confirm_message = message;
            $confirmationMessage.text(message).show();

            this.hideConfirmationMessage($confirmationMessage);
        },

        hideConfirmationMessage: function hideConfirmationMessage($confirmationMessage) {
            setTimeout(function fadeOutConfirmationMessage() {
                $confirmationMessage.fadeOut(1000);
            }, 3000);
        },

        getSelectedProduct: function getSelectedProduct() {
            var selectedOptions;
            if (this.pdpSelectedMatrixChilds.length !== 0) {
                selectedOptions = this.pdpSelectedMatrixChilds;

                if (selectedOptions.length === 1) {
                    return selectedOptions[0].internalid.toString();
                }
            }

            return this.pdpdItemInfo.item.internalid.toString();
        },

        getContext: function getContext() {
            return {
                selectedProduct: this.getSelectedProduct(),
                isVisible: this.isVisible ? 'style="display: block"' : '',
                buttonTxt: _.translate(Configuration.get('backInStockNotification.btnText'))
            };
        }
    });
});
